import React from 'react';
import { Box } from '@material-ui/core';
import { DashboardContainer } from 'layouts/v3-portal-layout/components';
import { WelcomeModal } from 'pages/v3-portal/dashboard/components';
import { Returns, Transactions } from 'modules/dashboard/treasure-reserve';
import { PortfolioTransition } from 'modules/dashboard/treasure-reserve/portfolio-transition/portfolio-transition';
import { FeatureFlag, FeatureFlags } from 'utils/feature-flags';
import { DashboardTransition } from 'modules/dashboard/dashboard-transition/dashboard-transition';
import { BankAccountsPlaidErrors } from 'modules/2023-q3/banking-page/v2/components/bank-accounts-plaid-errors/bank-accounts-plaid-errors';
import { OverviewTransition } from 'modules/2025-q3/bridge-returns-overview/overview-transition';

const TreasureReserveDashboard: React.FC = () => {
  return (
    <DashboardContainer>
      <Box mt={5} mb={5}>
        <OverviewTransition />
      </Box>

      <BankAccountsPlaidErrors variant="TreasureReserveDashboard" />

      <Box mt={5} mb={10}>
        <PortfolioTransition />
      </Box>

      <Box mb={10}>
        <Returns />
      </Box>

      <Transactions />

      <WelcomeModal />
    </DashboardContainer>
  );
};

export const Dashboard: React.FC = () => {
  return (
    <FeatureFlag
      disabled={<DashboardTransition />}
      enabled={<TreasureReserveDashboard />}
      flag={FeatureFlags.REACT_APP_DASHBOARD_TREASURE_RESERVE_ENABLED}
    />
  );
};
